import { ActionReducer, ActionReducerMap } from '@ngrx/store';
import { appReducer } from './reducers/app.reducer';
import { databasesReducer } from './reducers/databases.reducer';

export const appState: ActionReducerMap<any> = {
	app: appReducer,
	databases: databasesReducer
};

/**
 * Resestea el valor del estado
 *
 * @export
 * @param {ActionReducer<any>} reducer
 * @return {*}  {ActionReducer<any>}
 */
export function loadState(reducer: ActionReducer<any>): ActionReducer<any> {
	return function (state, action: any) {
		return reducer(state, action);
	};
}

/**
 * console.log all actions
 *
 * @export
 * @param {ActionReducer<any>} reducer
 * @return {*}  {ActionReducer<any>}
 */
export function debug(reducer: ActionReducer<any>): ActionReducer<any> {
	return function (state, action) {
		console.log('state', state);
		console.log('action', action);
		return reducer(state, action);
	};
}
